<template>
  <div>
<!--    <el-button @click="reload"></el-button>-->
    <el-table :data="dataList" border style="width: 100%">
      <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
          label="行号"
      ></el-table-column>
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="product.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          prop="product.attr2"
          label="克重"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column prop="materialCheckInCount" label="总来料数" header-align="center" align="center"></el-table-column>
      <el-table-column
          prop="materialCheckOutCount"
          label="总出料数"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="bomCount"
          label="实际单耗"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column prop="otherBomAmount" label="调整金额" header-align="center" align="center"></el-table-column>
      <el-table-column
          prop="price"
          label="平均单价"
          header-align="center"
          align="center"
          min-width="120"
      ></el-table-column>
      <el-table-column
          prop="materialAmount"
          label="总金额"
          header-align="center"
          align="center"
          min-width="120"
      ></el-table-column>
      <el-table-column
          prop="productSendCount"
          label="成品发货数"
          header-align="center"
          align="center"
          min-width="120"
      ></el-table-column>

    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </div>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import BigNumber from 'bignumber.js'
export default {
  name: "purchase-report",
  mixins: [mixinViewModule],
  components: {},
  props: {
    agreementId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/erp/purchase/settle/report",
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      dataForm: {
        orderId: "",
      },
    };
  },
  watch: {
    agreementId: {
      handler: function(newVal) {
        if (newVal && newVal !== "") {
          this.dataForm.orderId = newVal;
          this.reload();
        } else {
          this.dataList = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeTableBinding(dataList){

    }
  },
};
</script>
